import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
    heading: {
        color: '#4D72F8',
        fontSize: '20px',
        fontWeight: 600,
        fontFamily: "Calibri"
    },
    padding: {
        padding: 15,
    },
    divider: {
        color: '#C2C2C2',
        marginTop: '-14'
    },
    accordianNoFlex: {
        display: 'block'
    },
    bttns: { textAlign: 'center', marginTop: 10 },
    SaveButton: {
        background: '#4D72F8',
        border: '1px solid #ccc',
        textTransform:"capitalize",
        borderRadius: 5,
        fontFamily: 'Work Sans',
        fontWeight: 500,
        color: '#FFFFFF',
        fontSize: 15,
        padding: '6px 22px',
        '&:hover': {
            background: '#4D72F8',
            color: '#FFFFFF',
        },
    },
    userText: {
        // margin: '10px 0px 10px 0px',
        fontSize: 18,
        fontFamily: 'Work Sans',
        textAlign: 'left',
        fontWeight: 500,
        color: '#8392AB',
    },
    cancelButton: {
        fontFamily: 'Work Sans',
        fontWeight: 500,
        textTransform:"capitalize",
        marginLeft: 15,
        background: '#EFEFEF',
        border: '1px solid #AEAEAE',
        borderRadius: 5,
        color: '#8392AB',
        fontSize: 14,
        padding: '6px 22px',
    },
    errorMessage: {
        color: 'red',
        fontSize: '0.8rem',
        fontWeight: 500,
        marginTop: 0,
        marginBottom: 0,
    },
    modalCard: {
        margin: '10px 0px 10px 0px',
        borderRadius: 10,
        background: '#FFFFFF',
        boxShadow: '0 0 0.5em #E2E2E2',
        height:180
    },
    textGrid:{
        display: 'flex',
        justifyContent: 'flex-end',
        color: 'white',
        fontFamily: 'Calibri',
        float: 'right',
        fontSize: 14,
        padding: '6px 20px 6px 20px',
        textTransform: 'capitalize',
    },
    gridItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        color: 'white',
        fontFamily: 'Calibri',
        float: 'right',
        fontSize: 14,
        padding: '6px 20px 6px 20px',
        background: '#4D72F8',
        textTransform: 'capitalize',
        marginRight:15,
        '&:hover': {
            background: '#4D72F8',
            color: 'white'
        },
    },
    deactive:{
        alignItems: 'center',
        justifyContent: 'flex-end',
        color: 'white',
        fontFamily: 'Calibri',
        fontSize: 14,
        padding: '6px 20px 6px 20px',
        background: 'orangered',
        textTransform: 'capitalize',
        '&:hover': {
            background: 'orangered',
            color: 'white'
        },
    },
    active:{
        alignItems: 'center',
        justifyContent: 'flex-end',
        color: 'white',
        fontFamily: 'Calibri',
        fontSize: 14,
        padding: '6px 20px 6px 20px',
        background: 'green',
        textTransform: 'capitalize',
        '&:hover': {
            background: 'green',
            color: 'white'
        },
    },
    usersTable: {
        marginTop: 25,
        border: '1px solid rgba(194, 194, 194, 0.47)',
        borderRadius: 5,
    },
    tableHead: {
        fontFamily: 'Work Sans',
        color: 'rgba(0, 0, 0, 0.75)',
        fontWeight: 600,
        fontSize: 16,
    },
    yesButton: {
        display: "inline-block",
        verticalAlign: "top",
        background: "#219653",
        border: "0.75px solid rgba(168, 180, 222, 0.16)",
        // borderRadius: 3,
        // paddingLeft: 12,
        // paddingRight: 12,
        // paddingTop: 3,
        // paddingBottom: 3,
        padding: 10,
        color: "#ffffff",
        fontSize: 10,
        lineHeight: "8px",
        marginRight: 3,
        "&:hover": {
          background: "#219653",
          color: "#ffffff",
        },
      },
    CancelButton: {
        fontFamily: 'Work Sans',
        fontWeight: 500,
        marginLeft: 15,
        background: '#EFEFEF',
        border: '1px solid #AEAEAE',
        borderRadius: 5,
        color: '#8392AB',
        fontSize: 14,
        padding: '6px 22px',
    },
    tableBody: {
        fontFamily: 'Arial',
        color: '#929292',
        fontWeight: 500,
        fontSize: 14
    },
    assignBtn: {
        color: '#4D72F8',
        textTransform: 'capitalize',
        padding: '3px 15px'

    },
    actionButton: {
        borderWidth: 1,
        minWidth: 0,
        padding: '2px 20px',
    },
    adminIcon: {
        width: 25,
        height: 25,
        color: '#464646',
    },
    delete: {
        fontFamily: 'Work Sans',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: 16,
    },
    textColor: {
        color: '#464646',
        marginLeft: 10,
        fontWeight: 'bold',
    },
    pText: {
        textAlign: 'center', color: "#787878", fontWeight: 500, padding: '10px 2px'
    },
    flex:{
        display:"flex",
        margin:"7px"
    },
    deleteButton: {
        position: 'absolute',
        padding: 20,
        right: 0,
        borderRadius: 1,
        color: '#787878',
        background: '#F4F4F4',
        borderColor: '#F4F4F4',
      },
      deleteIconColor: {
        fontSize: 12,
        margin: 3,
        color: '#787878',
        borderColor: '#F4F4F4',
        '&:hover': {
          color: '#787878',
          borderColor: '#F4F4F4',
        },
        '&:active': {
          color: '#787878',
          borderColor: '#F4F4F4',
        },
      },
      addButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        color: 'white',
        fontFamily: 'Calibri',
        float: 'right',
        fontSize: 14,
        padding: '6px 20px',
        background: '#4D72F8',
        textTransform: 'capitalize',
        '&:hover': {
            background: '#4D72F8',
            color: 'white'
        },
        marginRight:15,
    },
      iconButton: {
        padding: '4px 8px',
        borderRadius: 5,
        color: '#FFFFFF',
        background: '#F4F4F4',
        border: '1px solid #ccc',
        boxSizing: 'border-box',
        width:'100px',
        height:'35px',
        '&:hover': {
          background: '#DDDDDD',
        },
        '&:active': {
          background: '#DDDDDD',
        },
      },
      deleteIconText: {
        fontSize: 12,
        fontFamily: 'Work Sans',
        fontStyle: 'normal',
        fontWeight: 600,
        letterSpacing: 0.217535,
        margin: 3,
        color: '#787878',
      },
    addonsTableHeading: {
        fontSize: 20,
        fontWeight: 500,
        color: "#3A416F",
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 12,
        paddingBottom: 9,
        borderBottom: "1.31653px solid #F5F5F5",
        fontFamily: "work Sans",
    },
    tableCard2: {
        background: "#FFFFFF",
        borderRadius: "10.3033px",
        boxShadow: "0px 17.1721px 23.1824px rgba(0, 0, 0, 0.05)",
        overflow: "visible",
        height: '220px',
        overflowY: 'auto',
        marginTop: 10
    },
    typography:{
        color:"#929292"
    },
    borderBox:{
        border:"1px solid darkgray",
        borderRadius:"4px"
    },
    totalAmount:{
        fontSize:"25px",
        fontWeight:700
    },
    licenseHeading:{
        fontSize:"15px",
        fontWeight:700
    },
    flexEnd:{
        display:"flex",
        justifyContent:"end"
    },
    simpleFlex:{
        display:"flex"
    }

}))